import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles';
import Skeleton from '../../../Common/Skeleton/Skeleton'
import s from './PaymentMethodSkeleton.css'


function PaymentMethodSkeleton() {
  return (
    <div className={s.paymentMethodSkeletonBox}>
      <Skeleton className={s.paymentMethodSkeletonLabel} />
      <Skeleton className={s.paymentMethodSkeletonInput} />
    </div>
  )
}

export default withStyles(s)(PaymentMethodSkeleton);
